import { useMemo } from "react";

import type { ListProjectsProject, User } from "../../hooks/useProject";
import { OverlayProvider } from "../Headers/components/ShareModal/components/MenuPortal";
import { type Link, LinkList, type LinkListTelemetryLocation } from "../LinkList/LinkList";
import { ProjectPromo } from "../ProjectPromo/ProjectPromo";

interface ProjectListProps {
  projects: ListProjectsProject[];
  users: User[];
  isShortVersion?: boolean;
  telemetryLocation: LinkListTelemetryLocation;
}

export const ProjectList: React.FC<ProjectListProps> = ({
  projects,
  users,
  isShortVersion,
  telemetryLocation,
}) => {
  const mappedProjectLinks = useMemo(() => {
    return projects.map((project) => {
      return {
        ...project,
        title: project.name,
        id: project.projectId,
        relativeURL: `/p/${project.projectId}`,
        uploadedAt: project.updatedAt,
        type: "project_page_link",
      } satisfies Link;
    });
  }, [projects]);

  const showPromo = mappedProjectLinks.length === 0;

  return (
    <OverlayProvider>
      <LinkList
        links={mappedProjectLinks}
        users={users}
        showPromo={showPromo}
        promoComponent={<ProjectPromo />}
        telemetryLocation={telemetryLocation}
        hideLocation={true}
        isShortVersion={isShortVersion}
      />
    </OverlayProvider>
  );
};
